import type { TrackingLinkSummary } from "../types";

export type TrackingLinkFunnelStage = {
  key: "redirects" | "contacts" | "started" | "completed";
  label: string;
  value: number;
  total: number;
};

export function trackingLinkFunnel(
  link: Pick<
    TrackingLinkSummary,
    "human_clicks" | "new_contacts" | "echoes_started" | "echoes_completed"
  >,
): TrackingLinkFunnelStage[] {
  const redirects = safeCount(link.human_clicks);
  const contacts = safeCount(link.new_contacts);
  const started = safeCount(link.echoes_started);
  const completed = safeCount(link.echoes_completed);

  return [
    {
      key: "redirects",
      label: "Human redirects",
      value: redirects,
      total: redirects,
    },
    {
      key: "contacts",
      label: "New contacts",
      value: contacts,
      total: redirects,
    },
    {
      key: "started",
      label: "Echoes started",
      value: started,
      total: redirects,
    },
    {
      key: "completed",
      label: "Echoes completed",
      value: completed,
      total: started,
    },
  ];
}

export function conversionPercentage(value: number, total: number) {
  if (!Number.isFinite(value) || !Number.isFinite(total) || total <= 0) {
    return 0;
  }
  return Math.max(0, (value / total) * 100);
}

export function progressPercentage(value: number, total: number) {
  return Math.min(100, conversionPercentage(value, total));
}

function safeCount(value: number | null | undefined) {
  if (!Number.isFinite(value) || Number(value) <= 0) return 0;
  return Number(value);
}
